import React, { useState, useEffect } from "react";
import { getIdData, addData, updateData } from "../../../lib/studentlessons";
import { LessonTypeSelect } from "../../ui/myselect";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../usercontext";

export default function GlobalStudentLessonEditForGrade({
  studentId,
  status,
  studentClass,
}) {
  //const [classforLesson, setClassForLesson] = useState(9);
  const [lessonType, setLessonType] = useState(null);
  const [lessonName, setLessonName] = useState();
  const [isActive, setIsActive] = useState(true);
  const { profile } = useAuth();
  const [data, setData] = useState([]);

  const navigate = useNavigate();
  //let { slug} = useParams();

  console.log("Gelenler", studentId, status, studentClass);
  //const studentId = profile.id;
  //const studentClass =  profile.class;

  async function GetData() {
    console.log("burada");
    const lessonnameData = await getIdData(status);
    setData(lessonnameData);
    setLessonName(lessonnameData[0].lessonName);
    setIsActive(lessonnameData[0].isActive);
    setLessonType(lessonnameData[0].lessonType);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (status === "Add") {
      console.log("Add");
      await addData({
        class: studentClass,
        lessonName: lessonName,
        isActive: isActive,
        studentId: studentId,
        lessonType: lessonType,
      });
    } else {
      console.log("Update");
      await updateData({
        id: status,
        lessonName: lessonName,
        isActive: isActive,
        lessonType: lessonType,
      });
    }

    //navigate("/student/student-lessons");
    navigate(-1);
  };

  useEffect(() => {
    console.log("slug", studentId);
    if (status !== "Add") {
      GetData();
    }
  }, [status]);
  return (
    <div className="col-12">
      <div className="settings-widget profile-details">
        <div className="settings-menu p-2">
          <div className="profile-heading p-1">
            <h3>{status === "Add" ? "New Course" : "Update Course"}</h3>
          </div>
          <div className="checkout-form personal-address add-course-info ">
            <form role="form" onSubmit={handleSubmit}>
              <div className="row mx-auto">
                <div className="col-9">
                  <div className="form-group">
                    <label className="form-control-label">Department</label>
                    <LessonTypeSelect
                      value={lessonType}
                      setValue={setLessonType}
                    />
                  </div>
                </div>
                <div className="col-9">
                  <div className="form-group">
                    <label className="form-control-label">Course</label>
                    <input
                      type="text"
                      value={lessonName}
                      onChange={(e) => setLessonName(e.target.value)}
                      className="form-control"
                      placeholder="Enter Course Name"
                      required
                    />
                  </div>
                </div>
                <div className="col-9">
                  <div className="form-group">
                    <label className="form-control-label">Is Active</label>
                    <div className="form-check form-switch check-on">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={isActive}
                        onChange={(e) => setIsActive(!isActive)}
                      />
                    </div>
                  </div>
                </div>
                <div className="update-profile d-flex justify-content-between">
                  <button type="submit" className="btn btn-primary">
                    {status === "Add" ? "Add Course" : "Update Course"}
                  </button>
                  <button
                    onClick={() => navigate(-1)}
                    className="btn btn-black btn-sm"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
